module.exports = __webpack_public_path__ + "img/8.c671f330.jpg";